<esp-deposit-free-text [autoPopulated]="isAutoPopulated"
                       [freeText]="depositFormDataService.description"
                       placeholder="{{'research.abstract.overline' | customTranslate}}">
</esp-deposit-free-text>
